import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { ShareSessionBody } from "~/pages/manifold-nextgen/components/conversations/share/ShareSessionBody";
import { useConversationShare } from "~/pages/manifold-nextgen/components/conversations/share/useConversationShare";
import { FeaturedSession } from "~/services/projects";

interface ShareConversationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  conversationId: string;
  projectId: string;
  isOwner: boolean;
  displayName: string;
  agentId?: string | null;
  featuredSessions: FeaturedSession[] | undefined;
}

export const ShareConversationDialog = ({
  open,
  onOpenChange,
  conversationId,
  projectId,
  isOwner,
  displayName,
  agentId,
  featuredSessions,
}: ShareConversationDialogProps) => {
  const share = useConversationShare(conversationId, open);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" onOpenAutoFocus={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>Share Session</DialogTitle>
          <DialogDescription>Anyone with the link can view, read-only.</DialogDescription>
        </DialogHeader>

        <ShareSessionBody
          share={share}
          projectId={projectId}
          isOwner={isOwner}
          displayName={displayName}
          agentId={agentId}
          featuredSessions={featuredSessions}
        />
      </DialogContent>
    </Dialog>
  );
};
